<template>
<div id="app">
           <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{$t('Version-Details')}} </v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="font-weight-light  caption "> {{ 'API Version:' }} {{  this.versiondate }}</span>
          </v-toolbar>
        </v-flex>
    <v-app id="inspire">
        <v-timeline class="pa-3">
            <v-timeline-item v-for="item in versionitems" :key="item.Ref" large>
                <template v-slot:icon>
                    <v-avatar>
                        <v-icon color="white">note
                        </v-icon>
                    </v-avatar>
                </template>
                <template v-slot:opposite>
                    <span>{{item.GirisTarih | dateformat}}</span>
                </template>
                <v-card class="elevation-2">
                      <v-card-text v-html="item.Aciklama"></v-card-text>
                    <v-card-title class="headline">{{item.VersiyonKod}}</v-card-title>
                </v-card>
            </v-timeline-item>
        </v-timeline>
    </v-app>
    <template>
        <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>
        </v-card>
    </template>
</div>
</template>

<script>
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"

export default {
     data() {
        return {
            versiondate:'',
        versionitems: [],
        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        }
    },
    beforeMount: beforeMount,
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    },
    methods:{
        GetVersion(){
        this.$http.post(auth.API_URL + 'api/AccountingDefinitions/VersionDate', '', {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        console.log(response);
    this.versiondate=response.body.VerDateStr;
                       console.log(this.versiondate);
    
                    }, (response) => {
                       
                    })
    },
    }
}

function beforeMount() {
    var params = {
        VersiyonID: 50
    }
    this.GetVersion();
    this.$http.post(auth.API_URL + 'api/Awed/VersionDetailList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.versionitems = response.body
        this.versionitems = this.versionitems.reverse()
    }, (response) => {
        this.text1 = this.$t('An-error-occurred-while-accessing-versions')
        this.snackbar = true
        this.loadingdialog = false
    })
}
</script>
